import { ITransformParams } from "../types/transform_params.js";
import { Easing, TransformBase, TransformType } from "./transform_base.js";
import { Transformable } from "./transformable.js";

export class TransformRotate<T extends Transformable> extends TransformBase {
  private readonly target: T;
  private from: number;
  private dest: number;

  constructor(
    target: T,
    is_important: boolean,
    from: number | null,    
    dest: number,            
    anim_start_time: number,
    duration: number,
    optional_params: ITransformParams = {}
  ) {
    super(
      TransformType.Rotating,
      anim_start_time,
      duration,
      is_important,
      optional_params
    );

    this.target = target;

    this.from = from !== null
      ? from
      : (is_important ? target.getRotationImportant() : 0);
    this.dest = dest;
    this.has_explicit_from = !is_important && from !== null;
  }

  private readonly has_explicit_from: boolean;
  public hasExplicitFrom(): boolean { return this.has_explicit_from; }

  public getType(): TransformType {
    return TransformType.Rotating;
  }

  protected getTarget(): T {
    return this.target;
  }

  protected initImportant(): void {
    if (this.isImportant()) {
      this.from = this.target.getRotationImportant();
    }
  }

  protected onUpdateTransform(eased: number): void {
    const angle = this.from + (this.dest - this.from) * eased;

    if (this.isImportant()) {
      this.target.setRotation(angle);
    } else {
      this.target.addToRotation(angle);
    }
  }

  public startValue(): number {
    return this.from;
  }

  public destValue(): number {
    return this.dest;
  }

  public setDestination(value: number): void {
    this.dest = value;
  }

  public toStrTransform(): string {
    return `TransformRotate(from ${this.from.toFixed(2)} to ${this.dest.toFixed(2)})`;
  }
}
